export default __webpack_public_path__ + "f1e73f05b6013507ca187363778644a1.svg";